import React, {useState, useEffect } from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'
import _ from 'lodash'



const pageSizeA =5;
const pageSize =5;
const pageSizeB =5;

const TecBusinessMain = () => {

  useEffect(()=>{

 
        
   
    setTimeout(() => {
              
    
    getroleAction() 
  
      
     }, 2000);
     
     
    
  })
    const[pop,setpop] = useState(false);
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken')); 
  
    const [sectionData, setSectionData] = useState([])
    const [paginatedPostsA, setpaginatedPostsA] = useState();
    const [currentPageA, setcurrentPageA] = useState(1);
    const [paginatedPosts, setpaginatedPosts] = useState();
     const [currentPage, setcurrentPage] = useState(1);
     const [paginatedPostsB, setpaginatedPostsB] = useState();
     const [currentPageB, setcurrentPageB] = useState(1);
  
   ///getTecData
  
  
   function getTecData()
   {
  

  
   fetch(`${BASE_URL}/Tec/GettecBusiness`, {
  
     method: 'GET',
  
     headers: {
  
       "Content-type": "application/json",
  
       "Accept": "application/json",
  
    
  
       "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
     },
  
     //body:JSON.stringify(data)
  
   }).then(response => response.json())
  
     .then(data => {
       console.log("DatasectionA", data);
       setSectionData(data)
       setpaginatedPostsA(_(data).slice(0).take(pageSize).value());
         }
     );
  
  
  
       }
  
       const pageCountA = sectionData? Math.ceil(sectionData.length/pageSizeB) :0;
       // if (pageCountB === 1)
       // return null;
       
       const pagesA = _.range(1, pageCountA+1)
       
       const paginationA =(pageNoA)=>{
       setcurrentPageA(pageNoA);
       const startIndex = (pageNoA - 1) * pageSizeA;
       const paginatedPostA = _(sectionData).slice(startIndex).take(pageSizeB).value();
       setpaginatedPostsA(paginatedPostA)
       }
       const onNextA = () => {
 
 
         paginationA(currentPageA + 1);
       };
       
       const onPreviousA = () => {
         paginationA(currentPageA - 1);
       };

    ///getData List


    const [DataList, setDataList] = useState([])

    function getTecDataList()
    {
  
 
  
    fetch(`${BASE_URL}/Tec/GettecBusinessList`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
    
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
       
        setDataList(data)
  
        setpaginatedPosts(_(data).slice(0).take(pageSize).value());
          }
      );
  
  
  
        }
        const pageCount = DataList? Math.ceil(DataList.length/pageSize) :0;
          // if (pageCount === 1)
          // return null;
          
          const pages = _.range(1, pageCount+1)
          
          const pagination =(pageNo)=>{
          setcurrentPage(pageNo);
          const startIndex = (pageNo - 1) * pageSize;
          const paginatedPost = _(DataList).slice(startIndex).take(pageSize).value();
          setpaginatedPosts(paginatedPost)
          }

          const onNext = () => {


            pagination(currentPage + 1);
          };
        
          const onPrevious = () => {
            pagination(currentPage - 1);
          };
    
  
         ///submitsectionData
  
   
     function submitsectionData(){
  
      var UserId= localStorage.getItem('UserId')
  
       var textData = document.getElementById("text").value;
      
  
       if(!textData){
  
         document.getElementById("AddErrA").innerHTML="Description Required"
  
       }
       else if(textData){
  
         document.getElementById("AddErrA").innerHTML=" "
  
       }
       
       
  
       if(textData){
  
  
  
      const body =
       {
         
         Text:textData, 
         
         SectionId:"05",
         ActiveStatus:0,
         DeleteStatus:0,
         CreatedBy:UserId
         
  
          
       
       }
       console.log('body',body);
  
     
       axios({
              method:"POST",
              url :`${BASE_URL}/Tec/AddtecData`,
              data:body, 
              headers: {
                   "Content-Type": "multipart/form-data",
                   'Authorization':bearer 
               }     
           }) 
   
          .then((response) =>{
          console.log(response.data);
     
     
          if(response.data.status === "Success"){
            
            setSuccessToast(true)
             
               
               setTimeout(() => {
               
                getTecData()
                setSuccessToast(false)
              
                closeDataAddForm()
               }, 2000);

              
             }
  
     
       })
       .catch(error => {
         console.log(error);
        alert("failed !")
    
  
       })
         
     }
  
     }
     ///submitsectionDataList
  
   
     function submitsectionDataList(){
  
      var UserId= localStorage.getItem('UserId')
  
       var textDataList = document.getElementById("Listtext").value;
      
  
       if(!textDataList){
  
         document.getElementById("ListAddErrA").innerHTML="List Required"
  
       }
       else if(textDataList){
  
         document.getElementById("ListAddErrA").innerHTML=" "
  
       }
       
       
  
       if(textDataList){
  
  
  
      const body =
       {
         
         List:textDataList, 
         
         SectionId:"05",
         ActiveStatus:0,
         DeleteStatus:0,
         CreatedBy:UserId
         
  
          
       
       }
       console.log('body',body);
  
     
       axios({
              method:"POST",
              url :`${BASE_URL}/Tec/AddtecDataList`,
              data:body, 
              headers: {
                   "Content-Type": "multipart/form-data",
                   'Authorization':bearer 
               }     
           }) 
   
          .then((response) =>{
          console.log(response.data);
     
     
          if(response.data.status === "Success"){
            
            setSuccessToast(true)
             
               
               setTimeout(() => {
               
                getTecDataList()
                
                setSuccessToast(false)
                closeDataListAddForm()
               }, 2000);

              
             }
  
     
       })
       .catch(error => {
         console.log(error);
        alert("failed !")
       
  
       })
         
     }
  
     }
  
  
   ////Get Particular Data PostMethodData
   const [EditSectionData, setEditSectionData] =useState([])
   function SelectParticular(Id){

    const body =
    {
      
     id:Id
    }
    console.log('body',body);
   
   
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/EdittecData`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                'Authorization':bearer 
            }     
        }) 
        
   
        .then((response) =>{
          console.log(JSON.stringify(response.data));
     
      
          setEditSectionData(response.data)

          
       })

    
       .catch(error => {
         console.log(error);
         
       })

   }
   function editSectionData(Id){
  
     SelectParticular(Id)
    document.getElementById("DataEditPop").style.display = "block";
  
  
      
   }
   ////Get Particular DataList PostMethodData
   const [EditSectionDataList, setEditSectionDataList] =useState([])
   function SelectParticularList(Id){
    const body =
    {
      
     id:Id
    }
    console.log('body',body);
   
   
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/EdittecDataList`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                'Authorization':bearer 
            }     
        }) 
        
   
        .then((response) =>{
          console.log(JSON.stringify(response.data));
     
      
          setEditSectionDataList(response.data)

          
       })

    
       .catch(error => {
         console.log(error);
         
       })
     
   
         
       

   }
   function editSectionDataList(Id){
  
    SelectParticularList(Id)
    document.getElementById("DataListEditPop").style.display = "block";
  
  
   }
  
  
   ////Get Particular Data PostMethodList
  
  


   function updateSectionData(Id){
  
  
    var UserId= localStorage.getItem('UserId')
    var TextData = document.getElementById("textA").value;
   
  
    if(!TextData){
  
      document.getElementById("ErrA").innerHTML="Description Required"
  
    }
    else if(TextData){
  
      document.getElementById("ErrA").innerHTML=" "
  
    }
    
   
  
   
    if(TextData){
  
  
    
  
  
  
  const body =
  {
    Id:Id,
    Text:TextData, 
   
    
    EditedBy:UserId
  
     
  
  }
  console.log('body',body);
  
  
  axios({
         method:"POST",
         url :`${BASE_URL}/Tec/UpdatetecData`,
         data:body, 
         headers: {
              "Content-Type": "multipart/form-data",
              'Authorization':bearer 
          }     
      }) 
  
     .then((response) =>{
     console.log(response.data);
  
  
     if(response.data.status === "Success"){
     
      setUpdateToast(true)
      closeDataEditForm()
          setTimeout(() => {
          
           getTecData()
           setUpdateToast(false)
           setcurrentPageA(1)
           
          }, 2000);
        }
  
  })
  .catch(error => {
    console.log(error);
    alert("failed !")
    
  })
    
  
  }
  
  }



  function updateSectionDataList(Id){
  
  
    var UserId= localStorage.getItem('UserId')
    var TextList = document.getElementById("ListtextA").value;
   
  
    if(!TextList){
  
      document.getElementById("ListErrA").innerHTML="List Required"
  
    }
    else if(TextList){
  
      document.getElementById("ListErrA").innerHTML=" "
  
    }
    
   
  
   
    if(TextList){
  
  
    
  
  
  
  const body =
  {
    Id:Id,
    List:TextList, 
   
    
    EditedBy:UserId
  
     
  
  }
  console.log('body',body);
  
  
  axios({
         method:"POST",
         url :`${BASE_URL}/Tec/UpdatetecDataList`,
         data:body, 
         headers: {
              "Content-Type": "multipart/form-data",
              'Authorization':bearer 
          }     
      }) 
  
     .then((response) =>{
     console.log(response.data);
  
  
     if(response.data.status === "Success"){
     
           setUpdateToast(true)
          closeDataListEditForm()
          setTimeout(() => {
          
           getTecDataList()
           setcurrentPage(1)
           setUpdateToast(false)
          
          }, 2000);
        }
  
  })
  .catch(error => {
    console.log(error);
    alert("failed !")
   
  })
    
  
  }
  
  }
  
   ///DeleteSectionA
  
   function ConfirmDelete(Id){

    SelectParticular(Id)
    document.getElementById("DataDeletePop").style.display = "block";
   }
   function closeForm(){
    document.getElementById("DataDeletePop").style.display = "none";

   }
  
   function DeleteSectionData(Id){
  
   

  
   const body =
    {
      Id:Id,
   
     
  
       
    
    }
    console.log('body',body);
  
  
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/DeletetecData`,
           data:body, 
           headers: {
              "Content-type": "application/json",
                'Authorization':bearer 
            }     
        }) 
  
       .then((response) =>{
       console.log(response.data);
  
  
       
             closeForm()
            setDeleteErrToast(true)
          
            setTimeout(() => {
            
             getTecData()
             setDeleteErrToast(false)
             setcurrentPageA(1)
             
            }, 2000);
           
            
          
  
    })
    .catch(error => {
      console.log(error);
      alert("failed !")
  
    })
      
   
  
  
  
  }
  
   ///DeleteSectionA
  
   function ConfirmDeleteList(Id){

    SelectParticularList(Id)
    document.getElementById("DataListDeletePop").style.display = "block";
   }
   function closeListForm(){
    document.getElementById("DataListDeletePop").style.display = "none";

   }
  
   function DeleteSectionDataList(Id){
  
   
    
  
   const body =
    {
      Id:Id,
   
     
  
       
    
    }
    console.log('body',body);
  
  
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/DeletetecDataList`,
           data:body, 
           headers: {
              "Content-type": "application/json",
                'Authorization':bearer 
            }     
        }) 
  
       .then((response) =>{
       console.log(response.data);
  
  
       
       
           setDeleteErrToast(true)
            closeListForm()
            setTimeout(() => {
            
              setcurrentPage(1)
             getTecDataList()
             setDeleteErrToast(false)
             
            }, 2000);
           
            
          
  
    })
    .catch(error => {
      console.log(error);
      alert("failed !")
     
    })
      
   
  
  
  
  }
  //closeAddFormData
  
  function closeDataAddForm(){
  
  
   
   
  
    document.getElementById("AddErrA").innerHTML=" "
   
   
    document.getElementById("tecform").reset();

    document.getElementById("DataAddPop").style.display = "none";
   
   
   
   
  }
  
   //closeEditForm
  
   function closeDataEditForm(){
  
    
    document.getElementById("ErrA").innerHTML=" "

    document.getElementById("teceditform").reset();
  
    
    document.getElementById("DataEditPop").style.display = "none";
   }


   //closeAddFormData
  
  function closeDataListAddForm(){
  
  
   
   
  
    document.getElementById("ListAddErrA").innerHTML=" "
   
   
    document.getElementById("Listtecform").reset();

    document.getElementById("DataListAddPop").style.display = "none";
   
   
   
   
  }
  
   //closeEditForm
  
   function closeDataListEditForm(){
  
    
    document.getElementById("ListErrA").innerHTML=" "

    document.getElementById("Listteceditform").reset();
  
    
    document.getElementById("DataListEditPop").style.display = "none";
   }
  
  
    //OpenAddForm
  
    function openDataForm(){
  
      document.getElementById("DataAddPop").style.display = "block";
  
    }
    function openDataListForm(){
  
      document.getElementById("DataListAddPop").style.display = "block";
  
    }
    function OpenTecGridMain(){
  
      getTecData()
      getTecDataList()
      
      document.getElementById("TecSelectMain").style.display="none"
      document.getElementById("TecGridMainA").style.display="block"
      document.getElementById("PopAAdd").style.display="none"
      document.getElementById("PopAAddList").style.display="none"
      document.getElementById("PopATable").style.display="none"
      setpop(true);
      
      setTimeout(()=>{
      setpop(false);
      getAssignedAction()
    
    },1000)
   
  
      }
    
    
      function OpenAboutContent(){
  
        getTecDataImage()
        
        document.getElementById("TecSelectMain").style.display="none"
        document.getElementById("TecGridMainB").style.display="block"
        document.getElementById("PopBAdd").style.display="none"
        document.getElementById("PopBTable").style.display="none"
        setpop(true);
       
        setTimeout(()=>{
        setpop(false);
        getAssignedActionFound()
        
        
      },1000)
      }
    
    
      function BackMain(){
    
        document.getElementById("TecGridMainA").style.display="none"
        document.getElementById("TecGridMainB").style.display="none"
        document.getElementById("TecSelectMain").style.display="block"
    
      }
  
  
      const [sectionDataImage, setSectionDataImage] = useState([])
      const [EditSectionDataImage, setEditSectionDataImage] =useState([])
    
     ///getTecDataImage
    
    
     function getTecDataImage()
     {
    
   
    
     fetch(`${BASE_URL}/Tec/GettecBusinessImage`, {
    
       method: 'GET',
    
       headers: {
    
         "Content-type": "application/json",
    
         "Accept": "application/json",
    
       
    
         "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
    
       },
    
       //body:JSON.stringify(data)
    
     }).then(response => response.json())
    
       .then(data => {
         console.log("DatasectionA", data);
         setSectionDataImage(data)
         setpaginatedPostsB(_(data).slice(0).take(pageSizeB).value());
           }
       );
    
    
    
         }

         const pageCountB = sectionDataImage? Math.ceil(sectionDataImage.length/pageSizeB) :0;
         // if (pageCountB === 1)
         // return null;
         
         const pagesB = _.range(1, pageCountB+1)
         
         const paginationB =(pageNoB)=>{
         setcurrentPageB(pageNoB);
         const startIndex = (pageNoB - 1) * pageSizeB;
         const paginatedPostB = _(sectionDataImage).slice(startIndex).take(pageSizeB).value();
         setpaginatedPostsB(paginatedPostB)
         }
         const onNextB = () => {


          paginationB(currentPageB + 1);
        };
        
        const onPreviousB = () => {
          paginationB(currentPageB - 1);
        };
           ///submitsectionDataImage
    
       const [fileDataImage, setFileDataImage] = useState();
       const [fileDataImageImg, setFileDataImageImg] = useState();
       // console.log(file)
       
       const handleFileChangeDataImage = (e) => {
        
           setFileDataImage(e.target.files[0]);
           setFileDataImageImg(URL.createObjectURL(e.target.files[0]));
       };
     
       function submitsectionDataImage(){
    
        var UserId= localStorage.getItem('UserId')
    
         
    
    
         if(!fileDataImage){
    
           document.getElementById("ImgAddErrA").innerHTML="Image Required"
    
         }
         else if(fileDataImage){
    
           document.getElementById("ImgAddErrA").innerHTML=" "
    
         }
         
        
    
         if(fileDataImage){
    
    
    
        const body =
         {
           
            
           Image:fileDataImage,
           SectionId:'05',
           ActiveStatus:0,
           DeleteStatus:0,
           CreatedBy:UserId
          
    
            
         
         }
         console.log('body',body);
    
       
         axios({
                method:"POST",
                url :`${BASE_URL}/Tec/AddtecDataImage`,
                data:body, 
                headers: {
                     "Content-Type": "multipart/form-data",
                     'Authorization':bearer 
                 }     
             }) 
     
            .then((response) =>{
            console.log(response.data);
       
       
            if(response.data.status === "Success"){
              
              setSuccessToast(true)
               
              
                 setTimeout(() => {
                 
                  getTecDataImage()
                  setSuccessToast(false)
                  closeDataImageAddForm()
                 }, 2000);
               }
    
       
         })
         .catch(error => {
           console.log(error);
           alert("failed !")
         
    
         })
           
       }
    
       }
    
    
     ////Get Particular Data PostMethodDataImage
    
     function SelectParticularImage(Id){


      const body =
      {
        
       id:Id
      }
      console.log('body',body);
     
     
      axios({
             method:"POST",
             url :`${BASE_URL}/Tec/EdittecDataImage`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  'Authorization':bearer 
              }     
          }) 
          
     
          .then((response) =>{
            console.log(JSON.stringify(response.data));
       
        
            setEditSectionDataImage(response.data)
     
           
       
         })
         .catch(error => {
           console.log(error);
           
         })
     }
     function editSectionDataImage(Id){

      SelectParticularImage(Id)
    
      document.getElementById("DataImageEditPop").style.display = "block";
    
    
    
     }
    
     function updateSectionDataImage(Id){
    
    
      var UserId= localStorage.getItem('UserId')
      
      var ImagefileDataImage = document.getElementById("Foundtecimage").src;
    
      
     
     
    
    
    
      
    
    
    
    const body =
    {
      Id:Id,
      
      Image:fileDataImage,
      OldImage:ImagefileDataImage,
      EditedBy:UserId
    
       
    
    }
    console.log('body',body);
    
    
    axios({
           method:"POST",
           url :`${BASE_URL}/Tec/UpdatetecDataImage`,
           data:body, 
           headers: {
                "Content-Type": "multipart/form-data",
                'Authorization':bearer 
            }     
        }) 
    
       .then((response) =>{
       console.log(response.data);
    
    
       if(response.data.status === "Success"){
       
            setUpdateToast(true)
            closeDataImageEditForm()
            setTimeout(() => {
            
             getTecDataImage()
             setUpdateToast(false)
             setcurrentPageB(1)
            }, 2000);
          }
    
    })
    .catch(error => {
      console.log(error);
      alert("failed !")
   
    })
      
    
    
    
    }
    
     ///DeleteSectionA
    
   
     function ConfirmDeleteImage(Id){

      SelectParticularImage(Id)
      document.getElementById("DataImageDeletePop").style.display = "block";
     }
     function closeImageForm(){
      document.getElementById("DataImageDeletePop").style.display = "none";

     }
     function DeleteSectionDataImage(Id){
    
     
     
    
     const body =
      {
        Id:Id,
     
       
    
         
      
      }
      console.log('body',body);
    
    
      axios({
             method:"POST",
             url :`${BASE_URL}/Tec/DeletetecDataImage`,
             data:body, 
             headers: {
                "Content-type": "application/json",
                  'Authorization':bearer 
              }     
          }) 
    
         .then((response) =>{
         console.log(response.data);
    
    
         
         
         closeImageForm()
              setDeleteErrToast(true)
              setTimeout(() => {
              
               getTecDataImage()
               setDeleteErrToast(false)
               setcurrentPageB(1)
              }, 2000);
             
              
            
    
      })
      .catch(error => {
        console.log(error);
        alert("failed !")
      
      })
        
     
    
    
    
    }
    //closeAddFormDataImage
    
    function closeDataImageAddForm(){
    
    
      setFileDataImage();
     
      setFileDataImageImg();
      document.getElementById("ImgAddErrA").innerHTML=" "
    
     
      document.getElementById("tecImageform").reset();
             
      document.getElementById("DataImageAddPop").style.display = "none";
     
     
    }
    
     //closeEditForm
    
     function closeDataImageEditForm(){
    
      setFileDataImage();
      setFileDataImageImg();
      
      document.getElementById("ImgErrA").innerHTML=" "
      document.getElementById("tecFoundeditform").reset();
    
      
      document.getElementById("DataImageEditPop").style.display = "none";
     }
    
      //OpenAddForm
    
      function openDataImageForm(){
    
        document.getElementById("DataImageAddPop").style.display = "block";
    
      }
  
   
    function getroleAction(){
  
     
  
      let LoginRole =  localStorage.getItem("Role");
   
      console.log('checkrole',LoginRole);
      const body =
      {
        
       role:LoginRole
      }
      console.log('body',body);
  
    
      axios({
             method:"POST",
             url :`${BASE_URL}/Tec/GetTecRoleAction`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": bearer,
              }     
          }) 
          
     
          .then((response) =>{
            console.log(response.data);
       
         
         
                  
            localStorage.setItem("LoginAction",JSON.stringify(response.data))
            localStorage.getItem("LoginAction");
         })
         .catch(error => {
           console.log(error);
    })
  }
  
    const[editicon,setediticon] = useState(false);
    const[delicon,setdelicon] = useState(false);
    const[denied,setdenied] = useState(false);    
    function getAssignedAction(){
  
  
  
    ////Admin
      let LoginRole =  localStorage.getItem("RoleId");
    
  
      let CheckSAdmin = LoginRole.includes("00")
      let CheckAdmin =LoginRole.includes("01")
  
  
    /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
      if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopAAdd').style.display ="block";
        document.getElementById('PopAAddList').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopAAdd').style.display ="block";
        document.getElementById('PopAAddList').style.display ="block";
      }
      else{
        document.getElementById('PopAAdd').style.display ="none";
        document.getElementById('PopAAddList').style.display ="none";
  
      }
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('PopATable').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('PopATable').style.display ="block";
      }
      else{
        document.getElementById('PopATable').style.display ="none";
  
      }
      if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
    
        setediticon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setediticon(true)
      }
      else{
        setediticon(false)
  
      }
      if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
  
        setdelicon(true)
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        setdelicon(true)
      }
      else{
        setdelicon(false)
  
      }
  
      if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){
  
        setdenied(true)
      }
      else{
  
        setdenied(false)
      }

      if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
        document.getElementById("TecActionDenied").innerHTML="View Table is not Assigned"
         }
    }
    function getAssignedActionFound(){
  
  
  
      ////Admin
        let LoginRole =  localStorage.getItem("RoleId");
      
    
        let CheckSAdmin = LoginRole.includes("00")
        let CheckAdmin =LoginRole.includes("01")
    
    
       /////////////Teammate
        let LoginAction =  localStorage.getItem("LoginAction");
        let TecRoleAction =  JSON.parse(LoginAction);
        let roleAction = TecRoleAction.map((e)=>e.roleAction);
        console.log(roleAction);
        
        let roles = roleAction.toString();
        let roleResult = roles.includes('Add')
        console.log(roleResult)
        
        let roleResultA = roles.includes('View')
        console.log(roleResultA)
        
        let roleResultB = roles.includes('Edit')
        console.log(roleResultB)
        
        let roleResultC = roles.includes('Delete')
        console.log(roleResultC)
    
    
       
    
        if(roleResult==true && CheckSAdmin==false && CheckAdmin==false){
    
          document.getElementById('PopBAdd').style.display ="block";
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          document.getElementById('PopBAdd').style.display ="block";
        }
        else{
          document.getElementById('PopBAdd').style.display ="none";
    
        }
        if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
    
          document.getElementById('PopBTable').style.display ="block";
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          document.getElementById('PopBTable').style.display ="block";
        }
        else{
          document.getElementById('PopBTable').style.display ="none";
    
        }
        if(roleResultB==true  && CheckSAdmin==false && CheckAdmin==false){
    
          setediticon(true)
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          setediticon(true)
        }
        else{
          setediticon(false)
    
        }
        if(roleResultC==true  && CheckSAdmin==false && CheckAdmin==false){
    
          setdelicon(true)
        }
        else if(CheckSAdmin==true || CheckAdmin==true){
          setdelicon(true)
        }
        else{
          setdelicon(false)
    
        }
  
        if(roleResultB==false  && roleResultC==false && CheckSAdmin==false && CheckAdmin==false){
  
          setdenied(true)
        }
        else{
    
          setdenied(false)
        }

        if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){
          document.getElementById("TecActionDeniedA").innerHTML="View Table is not Assigned"
           }
      }


      const[SuccessToast,setSuccessToast] = useState(false);  
      const[UpdateToast,setUpdateToast] = useState(false);  
      const[DeleteToast,setDeleteErrToast] = useState(false);  
  return (
    <>

    
      {/* Toast */}
      {SuccessToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Added Successfully</p></div>
   
  </div></div></div></div>:null}
   {/* Toast */}
  {DeleteToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Deleted Successfully</p></div>
   
  </div></div></div></div>:null} 


   {/* Toast */}
   {UpdateToast? <div className='tec-toastpop-fade'>
      <div className="modal-dialog" role="document">
      <div id='tecToastcontainer' style={{left:"20%"}}>
    <div id="Tec-success-box">
    <div className="Tec-Toastdot"></div>
    <div className="Tec-Toastdot Tec-Toasttwo"></div>
    <div className="Tec-Toastface">
      <div className="Tec-Toasteye"></div>
      <div className="Tec-Toasteye Tec-Toastright"></div>
      <div className="Tec-Toastmouth Tec-Toasthappy"></div>
    </div>
    <div className="Tec-Toastshadow scale"></div>
    <div className="Tec-Toastmessage"><h1 class="Tec-Toastalert">Success!</h1><p>Updated Successfully!</p></div>
   
  </div></div></div></div>:null}
    
    <div className='tec-addmain' id="TecSelectMain">
      
    
   {/* <div className="tec-addgrid-layout">
   <div className="tec-addmain-top">
   <div className='tec-addmain-back'>
   <Link to='/Tecsection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
   </div> 
   <span>Data</span>
   
   </div>
   </div> */}
   
   <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
   
   <p><span id="tectopspan"><span id="TecTitleMain">Business Intelligence & Analytics</span></span>
   <div className='tec-addmain-back'>
   <Link to="/TecSExpertise"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
   </div></p> 
   
   {/* <hr></hr> */}
   </div>   </div>  

   <div class="tec-hero"> 
  <div class="techero__title"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
</div>
 <div className='tecTwoList'>

  <div class="tecTwoList_responsive">
   <div id="TecSelectB" >
   
   <div id="items-body-content" onClick={OpenTecGridMain}>
   <span>Add Content</span>
   <i class="fa fa-angle-right"></i>
   </div>
   <div id="items-body-content" onClick={OpenAboutContent}>
   <span>Add Image</span>
   <i class="fa fa-angle-right"></i>
   </div>
   </div>
  
   </div>   </div> 
   
    </div>
   
   <div id="TecGridMainA" className='tec-addmain'>
   
   <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
   
   <p><span id="tectopspan"><span id="TecTitleMain">Content</span></span>
   <div className='tec-addmain-back'>
   <Link onClick={BackMain}><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
   </div></p> 
   
   {/* <hr></hr> */}
   </div>
   
    </div>   
   <div className='tec-addmain-add' id="PopAAdd">
      <button className='add-user' onClick={openDataForm}>  Add Description</button>
   </div>
   
   <div className='tec-addmain-add' id="PopAAddList">
      <button className='add-user' onClick={openDataListForm}>  Add List</button>
   </div>
    <div className='tec-sectionMain' id="PopATable" >
   
    {
  sectionData.length==0 ?null:( 
  <div>
   
   <div className='tectable'>
   
   <div class="tec-table_responsive">
   <table>
   <thead>
    <tr>
      <th>S.No</th>
      <th>Description</th>
    
      <th>Action</th>
    </tr>
   </thead>
   <tbody>
    {paginatedPostsA.map((e,index)=>{
    
   
    return<tr>
     <td>{index+1}</td>
    <td><div style={{inlineSize:"250px",overflowWrap:"break-word",wordWrap:"break-word"}}>{e.text}</div></td>
   
    
    <td style={{whiteSpace:"nowrap"}}>
      {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionData(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
    </td>
    </tr>
   } )}
   </tbody>
   </table>
   </div>
   </div>


   <br></br>
{pageCountA==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
   
       
       {currentPageA >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPreviousA} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageA} Of {pageCountA} 
         
            </span>   &nbsp; &nbsp;
        {currentPageA<pageCountA?<li className="page-item">
              <a class="tecpage-link" onClick={onNextA} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}

</div>

)}
<br></br>
{
  DataList.length==0 ? (<div id="TecApiFail">" No Data Found "</div>):(

<div style={{marginTop:"-50px"}}>
   <div className='tectable'>
   
   <div class="tec-table_responsive">

   <table>
   <thead>
    <th>S.No</th>
    <th>List</th>
    <th>Action</th>
    </thead>
   
   <tbody>
   {paginatedPosts.map((e,index)=>{
     return<tr>
     <td>{index+1}</td>
     <td>{e.list}</td>
     <td style={{whiteSpace:"nowrap"}}>
      {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionDataList(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDeleteList(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
    </td>
     </tr>
   } )}
   </tbody>
   </table>
   
   </div>
   </div>
   <br></br>
   {pageCount==1?null: <nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>pagination(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPage >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="tecpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
  </div>
  )}
   </div>
   {/* EditData */}
   <div className='tech-pop-fade' id="DataEditPop">
   <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"220px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT CONTENT</h4>
        <button type="button" className="close" onClick={closeDataEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      {EditSectionData.map((e)=>{
      return<form  id="teceditform" onSubmit={()=>updateSectionData(e.id)}>
      <div className="modal-body mx-3">
     <div className="md-form mb-5">
        <label id="sectionlable">Description</label> 
          <textarea type="text" id="textA"  defaultValue={e.text}/>
          <span id="ErrA" className='error'></span>
        </div> 
        
       
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>})}
    </div>
   </div>
   
   </div>
   
   {/* AddData */}
   <div className='tech-pop-fade' id="DataAddPop">
   
   <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"220px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD CONTENT</h4>
        <button type="button" className="close" onClick={closeDataAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecform" onSubmit={submitsectionData} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
           
        <label id="sectionlable">Description</label> 
          <textarea type="text" id="text"/>
          <span id="AddErrA" className='error'></span>
        </div> 
    
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
   </div>
   
   </div> 
   
   
   {/* List Edit and Add */}
   
   
   {/* EditData */}
   <div className='tech-pop-fade' id="DataListEditPop">
   <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"220px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT CONTENT</h4>
        <button type="button" className="close" onClick={closeDataListEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      {EditSectionDataList.map((e)=>{
      return<form  id="Listteceditform" onSubmit={()=>updateSectionDataList(e.id)}>
      <div className="modal-body mx-3">
     <div className="md-form mb-5">
        <label id="sectionlable">List</label> 
          <input type="text" id="ListtextA"  defaultValue={e.list}/>
          <span id="ListErrA" className='error'></span>
        </div> 
        
       
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>})}
    </div>
   </div>
   
   </div>
   
   {/* AddDataList */}
   <div className='tec-pop-fade' id="DataListAddPop">
   
   <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"220px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD LIST</h4>
        <button type="button" className="close" onClick={closeDataListAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="Listtecform" onSubmit={submitsectionDataList} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
           
        <label id="sectionlable">List</label> 
          <input type="text" id="Listtext"/>
          <span id="ListAddErrA" className='error'></span>
        </div> 
    
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
   </div>
   
   </div> 
   
   {/* DeletePopup */}

{EditSectionData.map((e)=>{ 
   return<div className="tec-pop-fade" id="DataDeletePop" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete This Data ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionData(e.id,e.userName)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
{/* DeletePopup */}

{EditSectionDataList.map((e)=>{ 
   return<div className="tec-pop-fade" id="DataListDeletePop" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeListForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete This Data ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionDataList(e.id,e.userName)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeListForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
   
   
   
    {pop? <div id="Loader">
   <Oval
   height={40}
   width={50}
   
   color="black"
   wrapperStyle={{}}
   wrapperClass=""
   visible={true}
   ariaLabel='oval-loading'
   secondaryColor="gray"
   strokeWidth={2}
   strokeWidthSecondary={2}
   
   />
     </div>
   :null}

<div id="TecDenied">
   <span id="TecActionDenied"></span>

   </div>
    </div>
    <div id="TecGridMainB" className='tec-addmain'>
   
     
    <div className="tec-addgrid-layout">
    <div className="tec-addmain-top">
   
   <p><span id="tectopspan"><span id="TecTitleMain">Images</span></span>
   <div className='tec-addmain-back'>
   <Link onClick={BackMain}><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i></Link>
   </div></p> 
   
   {/* <hr></hr> */}
   </div>
   
    </div>
   
    <div className='tec-addmain-add' id="PopBAdd">
      <button className='add-user' onClick={openDataImageForm}>  Add Image</button>
   </div>
   
    
    
   
   
   
   {/* EditDataImage */}
   <div className='tec-pop-fade' id="DataImageEditPop">
   {EditSectionDataImage.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"200px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT IMAGE</h4>
        <button type="button" className="close" onClick={closeDataImageEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecFoundeditform" onSubmit={()=>updateSectionDataImage(e.id)}>
      <div className="modal-body mx-3">
        
        
      <div className="text-center md-form mb-5" style={{marginTop:"-28px"}}>
     {/* <label id="sectionlable">Image</label> */}
     
      <input type="file" onChange={handleFileChangeDataImage} style={{opacity:"0",position:"relative",top:"50px",left:"200px",zIndex:"1"}}/>
      {!fileDataImageImg?<img id="Foundtecimage" src={e.image}  /> : <img id="Foundtecimage" src={fileDataImageImg}  />  }
      <span id="editimg-Tec"><i class="fa fa-pencil" aria-hidden="true" ></i></span>
      <span id="ImgErrA" className='error'></span>
     </div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
   </div>})}
   
   </div>
   
   {/* AddDataImage */}
   <div className='tec-pop-fade' id="DataImageAddPop">
   
   <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"210px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD IMAGE</h4>
        <button type="button" className="close" onClick={closeDataImageAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="tecImageform" onSubmit={submitsectionDataImage} >
      <div className="modal-body mx-3">
        
        <div className="md-form mb-5">
          <label id="sectionlable">Image</label>  
   
         <input type="file" onChange={handleFileChangeDataImage}/>
         
         <span id="ImgAddErrA" className='error'></span>
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='tec-adduser-button' type="submit">Add</button>
      </div>
      </form>
    </div>
   </div>
   
   </div> 
   
   
   {/* DeletePopup */}

{EditSectionDataImage.map((e)=>{ 
   return<div className="tec-pop-fade" id="DataImageDeletePop" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeImageForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete This Data ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="tec-adduser-button" onClick={()=>DeleteSectionDataImage(e.id,e.userName)} type='submit'>Delete</button>
        <button className="tec-adduser-button" onClick={closeImageForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
   
   
   
   <div className='tec-sectionMain' id='PopBTable'>
   
   {
   sectionDataImage.length==0 ? (<div id="TecApiFail">" No Data Found "</div>):(
<div>
   <div className='tectable'>
   
   <div class="tec-table_responsive">
 
   <table>
   <thead>
    <tr>
   
      <th>Image</th>
      <th>Action</th>
    </tr>
   </thead>
   <tbody>
    {paginatedPostsB.map((e)=>{
    
   
    return<tr>
    
   
    <td><img src={e.image} alt="imgA" id="sectionImage"></img></td>
    <td>
    {editicon?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editSectionDataImage(e.id)} id="tecEditicon"></i></span>:null} &nbsp;&nbsp;
      {delicon?<span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDeleteImage(e.id)} id="tecDelicon"></i></span>:null}
      {denied?<span className='error'>Denied</span>:null}
    </td>
    </tr>
   } )}
   </tbody>
   </table>
  
   </div>
   </div>
   <br></br>
   {pageCountB==1?null:<nav  id="tecpagenav">
    <ul className='pagination'>
      {/* {
        pagesB.map((page)=>(
          <li className={
            page === currentPageB ? "page-item active" : "page-item"
          }>
            
            
            
            <p className='tecpage-link'onClick={()=>paginationB(page)}>
            {page}
            </p>
            </li>
        ))
      } */}
        {currentPageB >1?<li className="page-item">
              <a class="tecpage-link" onClick={onPreviousB} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageB} Of {pageCountB} 
         
            </span>   &nbsp; &nbsp;
        {currentPageB<pageCountB?<li className="page-item">
              <a class="tecpage-link" onClick={onNextB} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>)}
   
   
   
    </div>
    {pop? <div id="Loader">
   <Oval
   height={40}
   width={50}
   id="Loader"
   color="black"
   wrapperStyle={{}}
   wrapperClass=""
   visible={true}
   ariaLabel='oval-loading'
   secondaryColor="gray"
   strokeWidth={2}
   strokeWidthSecondary={2}
   
   />
     </div>
   :null}
   <div id="TecDenied">
   <span id="TecActionDeniedA"></span>

   </div>
    </div>
    
    </>
  )
}

export default TecBusinessMain

